import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'ms-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class BadgeComponent {}
